<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    width="420"
  >
    <v-card class="pa-5">
      <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
        <v-card-text class="pa-0 text-body-1">
          {{ $t("discount-Mode") }}
        </v-card-text>
        <v-icon size="20" style="cursor: pointer" @click="onCancel">
          mdi-close
        </v-icon>
      </v-container>
      <v-radio-group v-model="selectedMode" column hide-details class="mt-0">
        <v-radio value="distribute">
          <template v-slot:label>
            <span class="header-discount-mode-title">{{ $t("header-discount-distribute") }}</span>
            <span class="text-caption grey--text mr-1">
              ({{ $t("header-discount-distribute-hint") }})
            </span>
          </template>
        </v-radio>
        <v-radio value="append">
          <template v-slot:label>
            <span class="header-discount-mode-title">{{ $t("header-discount-append") }}</span>
            <span class="text-caption grey--text mr-1">
              ({{ $t("header-discount-append-hint") }})
            </span>
          </template>
        </v-radio>
      </v-radio-group>
      <v-container class="pa-0 d-flex justify-end align-center gap-2 mt-6">
        <v-btn color="error" outlined height="32" @click="onCancel">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn color="primary" height="32" @click="onSubmit">
          {{ $t("submit") }}
        </v-btn>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import General from "@/Mixins/general";

export default {
  name: "HeaderDiscountModeDialog",
  mixins: [General],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedMode: "distribute",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.selectedMode = "distribute";
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancel");
      this.dialog = false;
    },
    onSubmit() {
      this.$emit("submit", this.selectedMode);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.header-discount-mode-title {
  font-size: 14px;
  line-height: 1.4;
}
</style>
